module.exports = __webpack_public_path__ + "static/media/pic-st2.d432c0b7.jpg";